export const moduleName = 'config';
